export default "https://cdn-static.gokick.com/assets/f7932cbd9535e06fbf9353fcd5d5fd5cf044a6ff/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";